 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"polyfills-core-js":"polyfills-core-js","polyfills-dom":"polyfills-dom","stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-02c995b5":"52930e64","chunk-09155df3":"2e268433","chunk-09162720":"9a851566","chunk-097e0872":"81c1f0c0","chunk-0e93a01c":"16448226","chunk-1bff95de":"de12714f","chunk-1c4705f4":"e1cb334d","chunk-1dbc15a2":"17123dc0","chunk-21a76241":"2bbaf8c0","chunk-25d83ca8":"1d971486","chunk-2d0a463b":"68f3e520","chunk-2d0ac931":"667708a1","chunk-2d0c073f":"50e276e1","chunk-2d0c211b":"b0b6c231","chunk-2d0cf315":"8bdd27d5","chunk-2d0d43da":"c6672c38","chunk-2d0d5c33":"d98bbfcf","chunk-2d0da04a":"50e3fbb9","chunk-2d0e5812":"59c57da3","chunk-2d213189":"37da8e05","chunk-2d217def":"a644b19b","chunk-2d217e6a":"9d5e5387","chunk-2d218068":"7765ed58","chunk-2d21a9aa":"51f415cb","chunk-2d21da73":"3021a7fc","chunk-2d222cca":"eaa1fa6a","chunk-2d22895d":"006e634b","chunk-2d23721e":"b3beb5de","chunk-2d237b00":"037b5772","chunk-30dd9750":"7cb8f4a8","chunk-37f2300e":"06cd27a8","chunk-3ed29de3":"6d1e139c","chunk-41c0f7a4":"5198d285","chunk-426f2f16":"7e1aff2d","chunk-462c869e":"04c2fe5c","chunk-47245a33":"b9e6a322","chunk-4739acd0":"5f4b483a","chunk-53b1137a":"a3202169","chunk-541ea42d":"42e37721","chunk-54bbd082":"03a33148","chunk-59d4c87c":"b31e07fc","chunk-5a8ac886":"6ef42fef","chunk-5ff96a24":"e1b9f3fb","chunk-69eb8776":"5096f8b2","chunk-6d375f34":"e8cf08c2","chunk-6e83591c":"43f6310a","chunk-504a075e":"c0e8e8b3","chunk-16a42bad":"c193aedd","chunk-7548ca2d":"46776066","chunk-79e15df5":"855b7230","chunk-1ebbfd48":"7eec25a3","chunk-2a804ced":"c221e585","chunk-35a2b034":"954e0d02","chunk-4166a5c8":"3c59e9c3","chunk-4309110b":"62155b01","chunk-52257b84":"060f34ba","chunk-5a991a28":"da5393e9","chunk-286862e6":"c7276371","chunk-58eaafad":"1b98ca86","chunk-e5198ae4":"1d4f2c81","chunk-804d9e56":"8bcbe601","chunk-7423fda6":"3afc4ca9","chunk-60aca8e0":"332d0e8f","chunk-315fe37a":"2d1fab1f","chunk-57e8eeac":"cda6684c","chunk-81ec2528":"d3fcea46","chunk-d16706aa":"98f0b392","chunk-05ed8119":"c281ffde","chunk-0a0425e4":"54e6bad9","chunk-74f30a31":"6750f401","chunk-1bdb0a3e":"80b892da","chunk-6ece4ef8":"41007a4e","chunk-605c91d9":"9be19535","chunk-67c03ece":"32332076","chunk-76a89bd4":"35265478","chunk-0499c28c":"62146e1d","chunk-76f11e92":"1ecdf616","chunk-7c534b92":"0d1d0040","chunk-90f334d2":"05c9e0a9","chunk-fc6db84e":"6a3a5101","chunk-79f1dac7":"c4d9090c","chunk-858cd918":"75bbbcad","chunk-8bb7f81e":"1979a9e9","chunk-a9395c36":"6457a75a","chunk-d0e8aa0a":"9263166d","chunk-d1b15efc":"ded7cc73","chunk-d8413eac":"2558759c","chunk-e5275ddc":"c05297dd","chunk-eaa2b130":"4044edc0","polyfills-core-js":"12be3461","polyfills-dom":"0298f9c0","stencil-polyfills-css-shim":"95cbdafc","stencil-polyfills-dom":"f9377d9e","chunk-2d0c9adc":"7b72019c","chunk-2d0c9758":"62f099a9","chunk-2d0b33e3":"2e69defc","chunk-2d0b9074":"cf6d8bbf","chunk-2d0b9280":"58416f48","chunk-2d0baac9":"ecbd8a2b","chunk-2d2376e6":"a05b70ee","chunk-2d216786":"97e8ffc1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-16a42bad":1,"chunk-1ebbfd48":1,"chunk-2a804ced":1,"chunk-35a2b034":1,"chunk-4166a5c8":1,"chunk-4309110b":1,"chunk-52257b84":1,"chunk-286862e6":1,"chunk-58eaafad":1,"chunk-e5198ae4":1,"chunk-804d9e56":1,"chunk-7423fda6":1,"chunk-60aca8e0":1,"chunk-315fe37a":1,"chunk-57e8eeac":1,"chunk-81ec2528":1,"chunk-d16706aa":1,"chunk-05ed8119":1,"chunk-0a0425e4":1,"chunk-74f30a31":1,"chunk-1bdb0a3e":1,"chunk-6ece4ef8":1,"chunk-605c91d9":1,"chunk-67c03ece":1,"chunk-76a89bd4":1,"chunk-0499c28c":1,"chunk-76f11e92":1,"chunk-7c534b92":1,"chunk-90f334d2":1,"chunk-fc6db84e":1,"chunk-d1b15efc":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"polyfills-core-js":"polyfills-core-js","polyfills-dom":"polyfills-dom","stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-02c995b5":"31d6cfe0","chunk-09155df3":"31d6cfe0","chunk-09162720":"31d6cfe0","chunk-097e0872":"31d6cfe0","chunk-0e93a01c":"31d6cfe0","chunk-1bff95de":"31d6cfe0","chunk-1c4705f4":"31d6cfe0","chunk-1dbc15a2":"31d6cfe0","chunk-21a76241":"31d6cfe0","chunk-25d83ca8":"31d6cfe0","chunk-2d0a463b":"31d6cfe0","chunk-2d0ac931":"31d6cfe0","chunk-2d0c073f":"31d6cfe0","chunk-2d0c211b":"31d6cfe0","chunk-2d0cf315":"31d6cfe0","chunk-2d0d43da":"31d6cfe0","chunk-2d0d5c33":"31d6cfe0","chunk-2d0da04a":"31d6cfe0","chunk-2d0e5812":"31d6cfe0","chunk-2d213189":"31d6cfe0","chunk-2d217def":"31d6cfe0","chunk-2d217e6a":"31d6cfe0","chunk-2d218068":"31d6cfe0","chunk-2d21a9aa":"31d6cfe0","chunk-2d21da73":"31d6cfe0","chunk-2d222cca":"31d6cfe0","chunk-2d22895d":"31d6cfe0","chunk-2d23721e":"31d6cfe0","chunk-2d237b00":"31d6cfe0","chunk-30dd9750":"31d6cfe0","chunk-37f2300e":"31d6cfe0","chunk-3ed29de3":"31d6cfe0","chunk-41c0f7a4":"31d6cfe0","chunk-426f2f16":"31d6cfe0","chunk-462c869e":"31d6cfe0","chunk-47245a33":"31d6cfe0","chunk-4739acd0":"31d6cfe0","chunk-53b1137a":"31d6cfe0","chunk-541ea42d":"31d6cfe0","chunk-54bbd082":"31d6cfe0","chunk-59d4c87c":"31d6cfe0","chunk-5a8ac886":"31d6cfe0","chunk-5ff96a24":"31d6cfe0","chunk-69eb8776":"31d6cfe0","chunk-6d375f34":"31d6cfe0","chunk-6e83591c":"31d6cfe0","chunk-504a075e":"31d6cfe0","chunk-16a42bad":"6e5a16ba","chunk-7548ca2d":"31d6cfe0","chunk-79e15df5":"31d6cfe0","chunk-1ebbfd48":"f737dfec","chunk-2a804ced":"ff7759a2","chunk-35a2b034":"c1f8e2e9","chunk-4166a5c8":"2c089930","chunk-4309110b":"0b4f0612","chunk-52257b84":"49a4c60b","chunk-5a991a28":"31d6cfe0","chunk-286862e6":"3e1c3824","chunk-58eaafad":"65c75e57","chunk-e5198ae4":"c5110fee","chunk-804d9e56":"17eeb512","chunk-7423fda6":"e4358697","chunk-60aca8e0":"b847e98e","chunk-315fe37a":"bef09578","chunk-57e8eeac":"23570451","chunk-81ec2528":"e584fe88","chunk-d16706aa":"aa4b704d","chunk-05ed8119":"e8b49c98","chunk-0a0425e4":"ae2f7eab","chunk-74f30a31":"e29c1cda","chunk-1bdb0a3e":"f3ac30b5","chunk-6ece4ef8":"497e3603","chunk-605c91d9":"e7082097","chunk-67c03ece":"1d20a427","chunk-76a89bd4":"82c9e3fe","chunk-0499c28c":"13985831","chunk-76f11e92":"9163f8c7","chunk-7c534b92":"3332476d","chunk-90f334d2":"0fcd3585","chunk-fc6db84e":"7aab5bc0","chunk-79f1dac7":"31d6cfe0","chunk-858cd918":"31d6cfe0","chunk-8bb7f81e":"31d6cfe0","chunk-a9395c36":"31d6cfe0","chunk-d0e8aa0a":"31d6cfe0","chunk-d1b15efc":"2c9cab68","chunk-d8413eac":"31d6cfe0","chunk-e5275ddc":"31d6cfe0","chunk-eaa2b130":"31d6cfe0","polyfills-core-js":"31d6cfe0","polyfills-dom":"31d6cfe0","stencil-polyfills-css-shim":"31d6cfe0","stencil-polyfills-dom":"31d6cfe0","chunk-2d0c9adc":"31d6cfe0","chunk-2d0c9758":"31d6cfe0","chunk-2d0b33e3":"31d6cfe0","chunk-2d0b9074":"31d6cfe0","chunk-2d0b9280":"31d6cfe0","chunk-2d0baac9":"31d6cfe0","chunk-2d2376e6":"31d6cfe0","chunk-2d216786":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
